import { useQuery } from '@tanstack/react-query';
import { fetchSubscriptionData } from '@/api/subscriptionsService';

export const useSubscripton = () => {
      return useQuery({
            queryKey: ['SubscriptionData'],
            queryFn: fetchSubscriptionData,
      });
};

